import createWithBsPrefix from './utils/createWithBsPrefix';
export default createWithBsPrefix('carousel-caption', {
  Component: 'div'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/es/CarouselCaption.js
// module id = 581
// module chunks = 0